<mat-card class="filter settingHeader">
  <div class="name">
    Manage Relation
  </div>
  <div class="quickAction">
    
    <mat-form-field appearance="">
      <mat-label>Search items in relation</mat-label>
      <input matInput type="text" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </div>
</mat-card>



<div class="documents">

    <mat-card class="example-list rowholder"  *ngIf="!ShowNoRecordFound">
      <div class="fieldRow head">
        <span class="moveicon"></span>
        <span class="fieldName">Relation Name</span>       
        <span class="editField">Edit</span>
        <span class="delete">Delete</span>
      </div>
      <div class="example-box fieldRow" *ngFor="let role of transactionroleList">
        <span class="moveicon"></span>
  
        <span class="fieldName">{{role.transactionalRoleName}}</span>
      
        <span class="editField">
          <button mat-icon-button class="editbtn" (click)="openDialogWithRef(myDialog,role)">
            <mat-icon>edit</mat-icon>
          </button>
        </span>
  
        <span class="delete">
          <button mat-icon-button class="trash" (click)="deleteTransactionRole(role)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </span>
      </div>
      <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [length]="paginatorTotalLength" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons  (page)="CallNextPrevPageData($event)"></mat-paginator>
     
    </mat-card>

    <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>


<ng-template #myDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Edit Transaction Roles
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Transaction Roles</mat-label>
      <input matInput [required]="true"  placeholder="Edit transaction roles" formControlName="transactionalRoleName" [(ngModel)]="editTransationRole.transactionalRoleName" />
      <mat-error
      *ngIf="formDialog.get('transactionalRoleName').invalid &&
        (formDialog.get('transactionalRoleName').dirty ||
        formDialog.get('transactionalRoleName').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary"   
  [disabled]="formDialog.invalid || !formDialog.dirty"  
  (click)="UpdateTransacrionRoleDetails()">Update
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
</button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>


<ng-template #myAddDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Add Transaction Role
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Transaction Role</mat-label>
      <input matInput [required]="true"  placeholder="Add transaction role" formControlName="transactionalRoleName"/>
      <mat-error
      *ngIf="formDialog.get('transactionalRoleName').invalid &&
        (formDialog.get('transactionalRoleName').dirty ||
        formDialog.get('transactionalRoleName').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>


</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="formDialog.invalid" 
  (click)="AddTransacrionRoleDetails(formDialog.value)">Save</button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>


<app-loader></app-loader>